import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useState } from 'react'
import Avatar from 'react-avatar'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { getFromSession, removeFromSession } from '../../helpers/GenericHelpers'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../models/RoutesModel'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { ThemeContext } from '../../models/ThemeContext'
import { ThemeTypes } from '../../models/SharedModel'

type Props = {}

const Profile = (props: Props) => {
    const navigate = useNavigate()
    const userName = getFromSession('user_name');

  // states
  const [headerDropdown, setHeaderDropdown] = useState(false);

  // helpers
  const toggleHeaderDropdown = () => setHeaderDropdown(prev => !prev)
  
  // const logout = () => {
  //   removeFromSession('user_name')
  //   removeFromSession('user_id')
  //   navigate(`/${RoutesEnum.LOGIN}`)
  // }
  
  const { themeName, modifyTheme } = useContext(ThemeContext);

  const changeTheme = () =>{
    if(themeName=== ThemeTypes.DARK_THEME){
      modifyTheme(ThemeTypes.BLUE_THEME)
    }else{
      modifyTheme(ThemeTypes.DARK_THEME)
    }
  }
  return (
    <div className="company-name">
          <Dropdown isOpen={headerDropdown} toggle={toggleHeaderDropdown}>
            <DropdownToggle>
              <Avatar 
                round
                size="30px"
                textSizeRatio={2}
                textMarginRatio={0.02}
                name={userName}
                maxInitials={2} 
              />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={changeTheme}>
                  change Theme
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
  )
}

export default Profile